import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import api from "@/lib/api";

export function usePromo() {
  const [promo, setPromo] = useState(null);
  useEffect(() => {
    api.get("/promotions/featured").then((r) => setPromo(r.data)).catch(() => {});
  }, []);
  return promo;
}

export function savingsFor(promo, price) {
  if (!promo || promo.scope === "product") return 0;
  if (promo.type === "percent") return +(price * promo.value / 100).toFixed(2);
  return Math.min(promo.value, price);
}

export default function PromoStrip({ promo }) {
  if (!promo) return null;
  const label = promo.type === "percent" ? `${promo.value}% off` : `$${promo.value} off`;
  return (
    <div data-testid="promo-strip" className="bg-[color:var(--evergreen)] text-white">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-5 py-2.5 text-center text-sm">
        <Ticket size={15} />
        <span>
          Launch offer — use code{" "}
          <strong className="font-mono-edge rounded bg-white/20 px-1.5 py-0.5">{promo.code}</strong>{" "}
          for <strong>{label}</strong> at checkout
        </span>
      </div>
    </div>
  );
}
